<div class="acs-page">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="acs-page__loading">
      <acs-loading-spinner size="large" message="Loading chapter officers..." />
    </div>

    <!-- Error State -->
    <acs-alert 
      *ngIf="error" 
      type="error" 
      title="Error Loading Chapter Officers"
      [message]="error" 
      [dismissible]="true"
      (dismissed)="error = null" />

    <!-- Main Content -->
    <div *ngIf="!isLoading" class="acs-page__content">
    
    <!-- Header Section -->
    <div class="acs-page-header">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">Chapter Officers</h1>
        <p class="acs-page-header__subtitle">
          {{ TotalOfficers }} total officer{{ TotalOfficers === 1 ? '' : 's' }}
        </p>
      </div>
    </div>

    <!-- Officer Data Grid -->
    <div class="acs-grid-section">
      <div class="acs-grid-section__header">
        <h2 class="acs-grid-section__title">Officer Details</h2>
        <p class="acs-grid-section__description">
          Complete chapter officer information with roles, terms, and contact details.
          Click on any officer row to view detailed information.
        </p>
      </div>

      <div class="acs-grid-section__container">
        <acs-data-grid
          #officerGrid
          [serverSide]="true"
          [entityName]="entityName"
          [columns]="gridColumns"
          [pageSize]="50"
          [infiniteScroll]="false"
          [autoLoad]="true"
          [showPagination]="true"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[10, 25, 50, 100]"
          [sortable]="true"
          [filterable]="true"
          [enableDropdownFilters]="true"
          [searchable]="true"
          searchPlaceholder="Search officers..."
          [selectable]="'none'"
          [exportable]="true"
          [exportFilenamePrefix]="'chapter-officers'"
          [virtualScrolling]="true"
          [stickyHeader]="true"
          emptyText="No officers found"
          (serverError)="onServerError($event)">
        </acs-data-grid>
      </div>
    </div>
  </div>
</div>